/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import store from './store';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'bootstrap/dist/css/bootstrap.css';
import './App.scss';
import { googleTranslateElementInit } from './scripts/initTranslate.js';
import './scripts/acctoolbar.min.js';

import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
// for notification animations
import 'animate.css';

import Routes from './routes';
import config from './config';

const App = () => {
  const intializeTranslate = () => {
    try {
      googleTranslateElementInit();
    } catch (e) {
      setTimeout(() => {
        intializeTranslate();
      }, 1000);
    }
  };

  useEffect(() => {
    if (!window.location.href.match('localhost:3000')) {
      if (!window.location.href.match(config.AppURL)) {
        // if its not https://www redirect there
        window.location.href = `${config.AppURL}${window.location.href.split('/app')[1]}`;
      }
    }

    intializeTranslate();
  }, []);

  // const keyValue = document['cookie'].match('(^|;) ?googtrans=([^;]*)(;|$)');
  // const currLang = keyValue ? keyValue[2].split('/')[2] : null;

  // const walkText = (node) => {
  //   if (node.nodeType === 3) {
  //     node.data = node.data.replace(/OPEN/gi, "APRA");
  //   }
  //   if (node.nodeType === 1 && node.nodeName !== "SCRIPT") {
  //     for (var i = 0; i < node.childNodes.length; i++) {
  //       walkText(node.childNodes[i]);
  //     }
  //   }
  // }

  // if (currLang === 'en'){
  //   walkText(document.body);
  // }

  return (
    <Provider store={store}>
      <ReactNotifications />
      <div id="wf-app-wrapper" className="font__poppins">
        {/* created placeholder for proper translate implementation */}
        <div id="translate-component-hidden">
          <div id="wfTranslator"></div>
        </div>
        <div id="wf-full-screen-wrapper">
          <div id="wf-scroll-wrapper">
            <Routes />
          </div>
        </div>
      </div>
    </Provider>
  );
};

export default App;
